export default {
  LOAD_CATALOG (state, payload) {
    state.catalogObject = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/catalog/vuex/mutations.js